// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoType } from './contactInfoType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TrialcardPrescriberV3ModelsSharedContactPreferenceModel {
    'contactInfoType'?: ContactInfoType;
    'isOptedIn'?: boolean | null;
    'isPreferred'?: boolean | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardPrescriberV3ModelsSharedContactPreferenceModel>> = [
        {
            "name":     "contactInfoType",
            "baseName": "contactInfoType",
            "type":     "ContactInfoType"
        },
        {
            "name":     "isOptedIn",
            "baseName": "isOptedIn",
            "type":     "boolean"
        },
        {
            "name":     "isPreferred",
            "baseName": "isPreferred",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardPrescriberV3ModelsSharedContactPreferenceModel.attributeTypeMap;
    }
}
